<div
  class="canvas z-1001 top-0 end-0 overflow-x-hidden h-full w-full fixed"
  id="canvas">
  <div
    [style.width.rem]="width()"
    class="end-0 p-2xl bg-white fixed"
    libClickOutSide
    [stopPropagations]="true"
    (clickOutside)="turnOffOutSideClick() ? null : close()"
    [class]="offCanvasContentClass()">
    <div class="flex justify-between items-center gap-lg">
      @if (showTitle()) {
        <p
          class="text-neutral-900 text-lg font-bold min-w-0 truncate"
          libTooltip
          [libTooltip]="title()"
          [hasCloseIcon]="false"
          placement="top"
          toolTipAction="mouseenter"
          [toolTipClass]="nameTooltipClass">
          {{ title() }}
        </p>
      } @else {
        <div class="min-w-0 flex-1">
          <ng-content select="[offCanvasHeader]" />
        </div>
      }

      <a
        class="border border-neutral-200 rounded-md cursor-pointer size-10 flex justify-center items-center shrink-0"
        (click)="close()">
        <lib-close-icon iconClass="size-6 text-neutral-900" />
      </a>
    </div>

    <!----------- content of right side ------------------->
    <ng-content />
  </div>
</div>
